module.exports = __webpack_public_path__ + "ENG_SPT8-Doctor_225002747-e849ef342f3bd2dfe6ee3a5917b5de43.png";